/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Login_Method_GrantedInputs */



/**
* | output |
* | --- |
* | "Sign-in method added" |
*
* @param {Audit_Details_Member_Login_Method_GrantedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_login_method_granted = /** @type {((inputs?: Audit_Details_Member_Login_Method_GrantedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Login_Method_GrantedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmeldemethode hinzugefügt")
	return /** @type {LocalizedString} */ ("Sign-in method added")
});